<div class="no-data-container">
    <div class="icon-warning"></div>
    <div class="no-found">{{heading || 'No results found'}}</div>
    <div class="try" *ngIf="subHeading">{{subHeading}}</div>
</div>